import React from "react";
import { TrusteeContainer } from "../../../containers";

const Trustee = (props) => {
  return <TrusteeContainer {...props} />;
};

export default Trustee;
